import moment from 'moment';

export type IUserType = 'notSet' | 'investor' | 'startupFounder';



export interface IApiFileData {
  id: string;
  key: string;
  title: string;
  fileName: string;
  extension?: string;
}



export interface IFundraisingCampaignSummary {
  id: string;
  name: string;
  creationDate?: moment.Moment | null;
  description?: string;
  stageDisplayName: string;
  targetCloseDate: moment.Moment | null;
  amountRaisedDollars: number;
  targetAmountDollars: number;
  completedAt: moment.Moment | null;
}



export interface IPage<TNode> {
  totalRows: number;
  pages: string[];
  nodes: TNode[];
}



export type NavigationState = {
  prevPath: string;
}

export function isNavigationState(state: unknown): state is NavigationState {
  return typeof state === 'object' && state !== null && 'prevPath' in state;
}
